import {keeperFetchResponse} from '@mail-core/dashboard/keeper/binding/fetch';

export const fetchWithLogs = async (
  url: string,
  type: 'text' | 'json',
  options?: RequestInit,
) => keeperFetchResponse(fetch(url, options), type);
